module.exports = __webpack_public_path__ + "img/biology.dbb62fb6.png";